const Header = () => {

    
    

    return ( 
        <div className='Header-Section'>
            <h1>Nibras</h1>
            
        </div>
     );
}
 
export default Header;